import styled from 'styled-components';
import {
    StrategyPageHeader,
    StrategyWideCardColumn,
} from '../../Strategy/styles';

export const PerformanceStack = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: stretch;
    gap: 44px;

    @media (min-width: 768px) {
        gap: 60px;
    }
`;

export const PerformancePageHeader = styled(StrategyPageHeader)`
    margin-bottom: 0 !important;
`;

export const PerformanceWideCardColumn = styled(StrategyWideCardColumn)`
    margin-top: 0 !important;
`;

export const PerformancePageInner = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .MuiOutlinedInput-root fieldset {
        border-width: 1px !important;
        border-color: rgba(242, 146, 5, 0.32) !important;
    }

    .MuiOutlinedInput-root:hover fieldset {
        border-color: rgba(242, 146, 5, 0.5) !important;
    }

    .MuiOutlinedInput-root.Mui-focused fieldset {
        border-color: #00d4ff !important;
    }
`;

export const PerformanceTabsArea = styled.div`
    padding: 4px 0 8px;
    color: rgba(232, 234, 255, 0.92);

    @media (min-width: 768px) {
        padding: 8px 0 12px;
    }

    .nav-tabs-performance {
        border-bottom: 1px solid rgba(242, 146, 5, 0.22);
        flex-wrap: wrap;
        gap: 6px;
        margin-bottom: 0;
    }

    .nav-tabs-performance .nav-item {
        margin-bottom: 0;
    }

    .nav-tabs-performance .nav-link {
        color: rgba(200, 210, 230, 0.88) !important;
        border: 1px solid transparent !important;
        border-radius: 10px 10px 0 0;
        padding: 10px 14px;
        font-weight: 600;
        font-size: 13px;
        transition: all 0.2s ease;
        background: transparent !important;
    }

    .nav-tabs-performance .nav-link:hover {
        color: #ffffff !important;
        background: rgba(242, 146, 5, 0.1) !important;
        border-color: rgba(242, 146, 5, 0.25) !important;
    }

    .nav-tabs-performance .nav-link.active {
        color: #f29205 !important;
        background: rgba(242, 146, 5, 0.14) !important;
        border-color: rgba(242, 146, 5, 0.4) !important;
        border-bottom-color: transparent !important;
        box-shadow: 0 -2px 14px rgba(242, 146, 5, 0.12);
    }

    .tab-content {
        color: #e8eaf4;
        padding-top: 1.25rem;
    }

    .tab-pane {
        animation: performanceTabFade 0.25s ease;
    }

    @keyframes performanceTabFade {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

/** Bloco de filtro dentro das abas (tema escuro, alinhado ao /trading/report) */
export const PerformanceFilterSection = styled.div`
    width: 100%;
    margin-bottom: 20px;
    padding: 0;
`;

export const PerformanceFilterTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(200, 210, 235, 0.9);
    margin-bottom: 16px;

    i {
        color: #f29205;
    }
`;

/** Mesmo padrão de /trading: coluna no mobile, botão Buscar full width e 44px. */
export const PerformanceFilterRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: stretch;

    @media (min-width: 768px) {
        flex-direction: row;
        align-items: flex-end;
        flex-wrap: wrap;
    }
`;

export const PerformanceFilterField = styled.div`
    flex: 1;
    min-width: 0;
    width: 100%;

    .MuiFormControl-root {
        width: 100%;
    }

    @media (min-width: 768px) {
        flex: 1 1 200px;
        max-width: 320px;
        width: auto;
    }
`;

export const PerformanceFilterActions = styled.div`
    display: flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    align-self: stretch;

    .MuiButton-root {
        width: 100% !important;
        max-width: 100%;
        justify-content: center;
        min-height: 44px !important;
        height: 44px !important;
        padding: 10px 18px !important;
        font-size: 14px !important;
        line-height: 1.25 !important;
        border-radius: 10px !important;
        box-sizing: border-box !important;
    }

    .MuiButton-label {
        gap: 6px;
    }

    @media (min-width: 768px) {
        width: auto;
        align-self: flex-end;
        justify-content: flex-start;

        .MuiButton-root {
            width: auto !important;
            max-width: none;
            min-height: 52px !important;
            height: 52px !important;
            padding: 0 22px !important;
            font-size: 14px !important;
        }
    }

    @media (min-width: 992px) {
        .MuiButton-root {
            min-height: 56px !important;
            height: 56px !important;
            padding: 0 28px !important;
            font-size: 15px !important;
        }
    }
`;

export const performancePrimaryButtonStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    textTransform: 'none',
    transition: 'all 0.3s ease',
};

/** Título acima do gráfico (período selecionado) */
export const PerformanceChartHeading = styled.div`
    margin: 24px 0 20px;
    font-size: 15px;
    font-weight: 700;
    color: rgba(230, 235, 250, 0.95);
    letter-spacing: 0.02em;

    i {
        color: #f29205;
        margin-right: 8px;
    }
`;

/** Container do gráfico Highcharts */
export const PerformanceChartWrap = styled.div`
    width: 100%;
    margin-top: 8px;
`;

/** Opções reutilizáveis para Highcharts no tema escuro (sem fundo branco) */
export const performanceHighchartsDark = {
    chart: {
        backgroundColor: 'transparent',
        plotBackgroundColor: 'transparent',
        plotBorderWidth: 0,
    },
    legend: {
        backgroundColor: 'transparent',
        itemStyle: { color: 'rgba(200, 210, 235, 0.92)' },
        itemHoverStyle: { color: '#ffffff' },
    },
    credits: {
        enabled: false,
    },
    /** Mesclar em xAxis junto com opções específicas (ex.: crosshair) */
    xAxisBase: {
        labels: { style: { color: 'rgba(180, 195, 220, 0.95)' } },
        lineColor: 'rgba(255, 255, 255, 0.12)',
        tickColor: 'rgba(255, 255, 255, 0.2)',
        gridLineColor: 'rgba(255, 255, 255, 0.08)',
    },
    /** Mesclar em yAxis; sobrescrever title.text no componente */
    yAxisBase: {
        labels: { style: { color: 'rgba(180, 195, 220, 0.95)' } },
        lineColor: 'rgba(255, 255, 255, 0.12)',
        tickColor: 'rgba(255, 255, 255, 0.2)',
        gridLineColor: 'rgba(255, 255, 255, 0.08)',
        title: {
            style: { color: 'rgba(200, 210, 235, 0.92)' },
        },
    },
};
